import React, { useRef, useState } from 'react'
import './PremsiCalculatorScreen.css'
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Nav from '../../components/Nav/Nav';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { auth } from '../../firebase';
import { Helmet } from 'react-helmet';
import { AiFillDollarCircle } from "react-icons/ai";
import { MdGroups } from "react-icons/md";
import { IoHeartSharp } from "react-icons/io5";
import { AiOutlineSafety } from "react-icons/ai";
import PremsiTutorialButton from '../../components/PremsiTutorialButton';
import ReferralCTA from '../../components/ReferralCTA/ReferralCTA';
function PremsiCalculator() {
    const [showearnings, setshowearnings] = useState(1);

    const [followercount, setfollowercount] = useState(0);
    const [nrpms, setnrpms] = useState(0);
    const [avgpricepms, setavgpricepms] = useState(0);
    const [nrgroups, setnrgroups] = useState(0);
    const [avgpricegroups, setavgpricegroups] = useState(0);

    const [earnings, setearnings] = useState();

    const myRef = useRef(null)
    const navigate = useNavigate()

    const calculateEarnings = () => {
        let nrbuyerpm = 0.005 * followercount
        let nrbuyergroup = 0.005 * followercount

        let earnedpm = nrpms * avgpricepms * nrbuyerpm * 0.3
        let earnedgroup = nrgroups * avgpricegroups * nrbuyergroup * 0.3 * 3

        //console.log("calculateEarnings", nrbuyerpm, nrbuyergroup, earnedpm, earnedgroup)

        setearnings(Number(earnedgroup) + Number(earnedpm))
    }

    return (
        <>
            <Helmet>
                {/* Open Graph Meta Tags */}
                <meta property="og:title" content="Premsi | Calculate your potential earnings with Premsi" />
                <meta property="og:description" content="Premsi | Calculate your potential earnings with Premsi . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <meta property="og:url" content="https://premsi.com/calculator" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
                <meta property="og:site_name" content="Premsi - sell digital content" />

                <title>Premsi | Calculate your potential earnings with Premsi</title>
                <meta name="description" content="Premsi | Calculate your potential earnings with Premsi . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <link rel="canonical" href="https://premsi.com/calculator" />
            </Helmet>
            <Nav />
            {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}

            <div className="calc-page">
                <div className="calc-page__main whatispremsimainmain">
                    <div className="calc-page__title-row">
                        <h1 className="calc-page__title">Calculate your potential earnings with Premsi</h1>
                        <img loading="lazy" src={require('../../images/pblue-min.webp')} className="calc-page__logo" alt="Premsi.com logo app icon" />
                    </div>

                    <div className="calc-page__field">
                        <label className="calc-page__label calcp" htmlFor="calc-followers">Your Social Media Following:</label>
                        <input id="calc-followers" onChange={(e) => setfollowercount(e.target.value)} className="calc-page__input" type="number" placeholder="# followers" />
                    </div>

                    <div className="calc-page__field">
                        <label className="calc-page__label calcp" htmlFor="calc-pms">Premium Messages:</label>
                        <p className="calc-page__hint">How many different Premium Messages (Videos/Pics/PDFs) do you think you will sell?</p>
                        <input id="calc-pms" onChange={(e) => setnrpms(e.target.value)} className="calc-page__input" type="number" placeholder="# of PMs" />
                    </div>

                    <div className="calc-page__field">
                        <p className="calc-page__hint">Average price of PMs:</p>
                        <input onChange={(e) => setavgpricepms(e.target.value)} className="calc-page__input" type="number" placeholder="Avg. price of PMs" />
                    </div>

                    <div className="calc-page__field">
                        <label className="calc-page__label calcp" htmlFor="calc-groups">Paid Groups:</label>
                        <p className="calc-page__hint">How many different Paid Groups do you think you will offer?</p>
                        <input id="calc-groups" onChange={(e) => setnrgroups(e.target.value)} className="calc-page__input" type="number" placeholder="# of Groups" />
                    </div>

                    <div className="calc-page__field">
                        <p className="calc-page__hint">Average monthly price of all Groups:</p>
                        <input onChange={(e) => setavgpricegroups(e.target.value)} className="calc-page__input" type="number" placeholder="Avg. price of Groups" />
                    </div>

                    <p className="calc-page__teaser">Soon you'll be able to sell courses and paid podcasts</p>

                    <button type="button" className="calc-page__btn calc-page__btn--primary" onClick={() => calculateEarnings()}>
                        Calculate potential earnings
                    </button>

                    {earnings !== null && earnings !== undefined && (
                        <div className="calc-page__result">
                            <p className="calc-page__result-value">Your potential earnings are {earnings}$</p>
                            <button type="button" className="calc-page__btn calc-page__btn--primary" onClick={() => navigate("/alternativehomepage")}>Start Now</button>
                        </div>
                    )}

                    <div className="calc-page__fees everyuserdivsecondnotlogin">
                        <div className="calc-page__fees-inner everyuserdivinnersecondnotlogin">
                            <h2 className="calc-page__fees-title">Fees</h2>
                            <p className="calc-page__fees-text priceexplanation">And all that for 0$. No monthly subscription. No credit card required. Nothing!</p>
                            <p className="calc-page__fees-text priceexplanation">We only earn once you make money and 85% goes directly to you</p>
                        </div>
                    </div>

                    <div className="calc-page__section-title-row whatispremsitop">
                        <h2 className="calc-page__section-title">What is Premsi?</h2>
                        <img loading="lazy" src={require('../../images/pblue-min.webp')} className="calc-page__logo" alt="Premsi.com logo app icon" />
                    </div>

                    <p className="calc-page__intro premsiexplanationp">Premsi is the social media where you can post, market and sell all your digital content in our App <span className="font-body-inline">+</span> Website in 30sec</p>

                    <div className="calc-page__features premsi-features-section">
                        <div className="calc-page__feature premsi-feature">
                            <AiFillDollarCircle size={50} color="#009ffd" />
                            <h3 className="calc-page__feature-title premsi-feature-title">Creative Ownership</h3>
                            <p className="calc-page__feature-text premsi-feature-text">Premsi creators own 100% of their content and keep 85% of all earnings.</p>
                        </div>
                        <div className="calc-page__feature premsi-feature">
                            <MdGroups size={50} color="#009ffd" />
                            <h3 className="calc-page__feature-title premsi-feature-title">Inclusivity</h3>
                            <p className="calc-page__feature-text premsi-feature-text">All creators deserve a safe and inclusive space to connect and share.</p>
                        </div>
                        <div className="calc-page__feature premsi-feature">
                            <IoHeartSharp size={50} color="#009ffd" />
                            <h3 className="calc-page__feature-title premsi-feature-title">Freedom</h3>
                            <p className="calc-page__feature-text premsi-feature-text">Creators are free to express their most authentic selves through their content.</p>
                        </div>
                        <div className="calc-page__feature premsi-feature">
                            <AiOutlineSafety size={50} color="#009ffd" />
                            <h3 className="calc-page__feature-title premsi-feature-title">All<span className="font-body-inline">-</span>In<span className="font-body-inline">-</span>One</h3>
                            <p className="calc-page__feature-text premsi-feature-text">Exploring / Marketing / Selling all on Premsi possible</p>
                        </div>
                    </div>

                    <PremsiTutorialButton />
                </div>

                <ReferralCTA
                    title={<>Refer friends <span className="font-body-inline">&</span> receive 5<span className="font-body-inline">%</span> of their spendings for life</>}
                    subtitle={<>Whenever they subscribe to Premsi<span className="font-body-inline">+</span>, tip someone or buy a premium message you'll earn.</>}
                    onButtonClick={() => navigate("/profile")}
                />
            </div>

            {/*<div className='explainappdivwhatcreatorsachieved'>
                <h2>What our creators achieve ❤️</h2>

                {showearnings === 1 ?
                    <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/1pm.webp')} alt="Premsi.com earnings example" />
                    : (showearnings === 2 ?
                        <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/2pm.webp')} alt="Premsi.com earnings example" />
                        : (showearnings === 3 ?
                            <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/3pm.webp')} alt="Premsi.com earnings example" />
                            : (showearnings === 4 ?
                                <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/4pm.webp')} alt="Premsi.com earnings example" />
                                :
                                <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/5pm.webp')} alt="Premsi.com earnings example" />
                            )))}

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 14 }}>
                    <div onClick={() => setshowearnings(1)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 1 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(2)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 2 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(3)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 3 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(4)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 4 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(5)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 5 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                </div>
            </div>*/}

            <Footer />
        </>
    )
}

export default PremsiCalculator
